export default Object.freeze({
  START: 'start',

  PAUSE: 'pause',

  STOP: 'stop',
});
